import type { SVGProps } from 'react'

const ProductBasedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      d="M11.5142 24.3273H5.55566C2.79424 24.3273 0.555664 22.0888 0.555664 19.3273V7.97378M0.555664 7.97378L3.33303 3.08562C4.22158 1.52176 5.88165 0.555664 7.68031 0.555664H12.3572M0.555664 7.97378H12.3572M24.1587 7.97378L21.3814 3.08562C20.4928 1.52176 18.8328 0.555664 17.0341 0.555664H12.3572M24.1587 7.97378H12.3572M24.1587 7.97378V11.6828M12.3572 7.97378V0.555664"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3772 26.0601V14.6218C20.3772 14.2784 20.6556 14 20.999 14H22.7704C23.1138 14 23.3922 14.2784 23.3922 14.6218V26.0601"
      stroke="#0066FF"
      strokeWidth="1.1306"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.363 26.0005V19.4426C17.363 19.0992 17.6414 18.8208 17.9849 18.8208H19.7562C20.0997 18.8208 20.3781 19.0992 20.3781 19.4426V26.0005"
      stroke="#0066FF"
      strokeWidth="1.1306"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3477 26.0643V21.8621C14.3477 21.5186 14.6261 21.2402 14.9695 21.2402H16.7409C17.0843 21.2402 17.3627 21.5186 17.3627 21.8621V26.0643"
      stroke="#0066FF"
      strokeWidth="1.1306"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ProductBasedIcon
